import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogData } from './confirm.model';
import { from, isObservable } from 'rxjs';

@Component({
  selector: 'vex-confirm-dialog-box',
  templateUrl: './confirm-dialog-box.component.html',
  styleUrls: ['./confirm-dialog-box.component.scss']
})
export class ConfirmDialogBoxComponent implements OnInit {
  isConfirming = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private dialogRef: MatDialogRef<ConfirmDialogBoxComponent>
  ) {}

  ngOnInit(): void {
    // Backdrop / Esc must not dismiss — only Cancel / X / successful Confirm.
    this.dialogRef.disableClose = true;
  }

  /** X button: dismiss with no choice. Callers must not treat this as Cancel. */
  onDismiss(): void {
    if (this.isConfirming) {
      return;
    }
    this.dialogRef.close();
  }

  onCancel(): void {
    if (this.isConfirming) {
      return;
    }
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    if (this.isConfirming) {
      return;
    }

    if (!this.data.confirmAction) {
      this.dialogRef.close(true);
      return;
    }

    this.isConfirming = true;
    const result = this.data.confirmAction();
    const action$ = isObservable(result) ? result : from(Promise.resolve(result));

    action$.subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: () => {
        this.isConfirming = false;
      },
    });
  }
}
